import { render, staticRenderFns } from "./Hospitals.vue?vue&type=template&id=c675d5d4&scoped=true&"
import script from "./Hospitals.vue?vue&type=script&lang=js&"
export * from "./Hospitals.vue?vue&type=script&lang=js&"
import style0 from "./Hospitals.vue?vue&type=style&index=0&id=c675d5d4&prod&lang=scss&scoped=true&"
import style1 from "./Hospitals.vue?vue&type=style&index=1&id=c675d5d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c675d5d4",
  null
  
)

export default component.exports